/**
 *
 * NewTreatmentPlanningStep
 *
 */
import { PureComponent } from "react";
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import styled from "styled-components";
import StepArrows from "components/MultiStep/StepArrows";
import LoadingAnimation from "basicComponents/LoadingAnimation/LoadingAnimation";
import ActionButton from "basicComponents/ActionButton/ActionButton";
import {
  makeSelectCheckAvailabilityFailedMessage,
  makeSelectCheckAvailabilityLoading,
  makeSelectPatient,
  makeSelectPlannedDay,
  makeSelectTimeSlot,
  makeSelectTimeSlotData,
  makeSelectTimeSlotDataLoading,
  makeSelectTimeWindow,
  makeSelectTreatmentDrivers,
  makeSelectTreatmentDuration,
  makeSelectTreatmentPlan,
  makeSelectTreatmentsNewTreatment,
  makeSelectTreatmentToPlan,
} from "containers/NewTreatmentPage/selectors";
import moment from "moment";
import OrderMessages from "../../Order/messages";
import TreatmentDatePicker from "components/TreatmentDatePicker/TreatmentDatePicker";
import {
  checkAvailability,
  getPlannedDays,
  getTimeSlotDataAction,
  getTreatmentDrivers,
  getTreatmentDuration,
  selectTimeSlot,
  selectTimeWindow,
} from "containers/NewTreatmentPage/actions";
import Header from "basicComponents/Header/Header";
import SubHeader from "basicComponents/SubHeader/SubHeader";
import {
  filterSortTimeSlots,
  makeSelectPlannedTimeSlots,
  makeSelectPlannedTimeSlotsLoading,
  makeSelectTreatments,
} from "containers/App/selectors";
import { getPlannedTimeSlotsAction } from "containers/App/actions";
import DayChart from "components/DayChart/DayChart";
import DateBlocks from "components/DateBlocks/DateBlocks";
import DateTimePicker from "components/DateTimePicker/DateTimePicker";
import { WarningMessages } from "basicComponents/FormComponents/FormComponents";
import history from "utils/history";
import GlobalMessages from "messages/messages";
import { getColorFitting, getStateFitting, STATES } from "utils/timeGap";
import { makeSelectLocale } from "../../LanguageProvider/selectors";
import messages from "./messages";
import IconActionButton from "../../../basicComponents/IconActionButton/IconActionButton";
import { DATE_FORMATS, isOutOfMax, parse } from "../../../utils/Date";
import { setTreatmentFromTimeSlotAction } from "../../PageState/actions";
import { makeSelectTreatmentFromTimeSlot } from "../../PageState/selectors";
import EditIcon from "../../../images/EditIcon";
import NewTreatmentHeader from "../../NewTreatmentHeader/NewTreatmentHeader";
import { getBearer, hasRole, ROLES } from "utils/userStorage";
import { createSortedAvailableTimeWindows } from "../../../utils/SortedAvailableTimeWindow";
import { ERROR_CODES } from "../../../utils/Polling/Polling";
import { buildTimes, toMoment } from "components/TimeSlotEditor/utils";
import AgendaPlannedTreatment from "components/AgendaView/AgendaPlannedTreatment";
import { makeSelectPractice } from "containers/PracticePage/selectors";
import ToggleButton from "components/ToggleButton/ToggleButton";
import DocumentOrderModal from "../../ProductQuestionFlow/DocumentOrderModal";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import DurationPicker from "../../../components/DurationPicker/DurationPicker";
import CustomInputComponent from "components/CustomInputComponent/CustomInputComponent";
import RefrezhButton from "components/RefrezhButton";
import { DEFAULT_LOCALE } from "i18n";

export class NewTreatmentPlanningStep extends PureComponent {
  // static propTypes = {
  //   treatments: PropTypes.array.isRequired,
  //   treatmentPlan: PropTypes.object.isRequired,
  //   treatmentToPlan: PropTypes.object.isRequired,
  //   plannedTimeSlots: PropTypes.array.isRequired,
  //   plannedTimeSlotsLoading: PropTypes.bool,
  //   timeWindow: PropTypes.object,
  //   onNext: PropTypes.func.isRequired,
  //   onBack: PropTypes.func.isRequired,
  //   locale: PropTypes.string.isRequired,
  //   getPlannedTimeSlots: PropTypes.func.isRequired,
  //   selectTimeWindow: PropTypes.func.isRequired,
  //   patient: PropTypes.object.isRequired,
  //   onClose: PropTypes.func.isRequired,
  //   setTreatmentFromTimeSlot: PropTypes.func.isRequired,
  //   treatmentFromTimeSlot: PropTypes.object,

  //   // TimeSlot
  //   timeSlot: PropTypes.object,
  //   onTimeSlotChanged: PropTypes.func.isRequired,

  //   // timeSlotData
  //   getTimeSlotData: PropTypes.func.isRequired,
  //   timeSlotData: PropTypes.object,
  //   timeSlotDataLoading: PropTypes.bool,
  //   checkAvailability: PropTypes.func.isRequired,
  //   loading: PropTypes.bool,

  //   // calendar icons and plannedTimeSlots
  //   agendaTreatments: PropTypes.array,

  //   // drivers
  //   drivers: PropTypes.array,
  //   onGetDrivers: PropTypes.func,
  //   onGetTreatmentDuration: PropTypes.func,
  //   treatmentDuration: PropTypes.number,
  //   manufacturerOffice: PropTypes.bool,
  //   withScanner: PropTypes.bool,
  // };

  state = {
    available: {},
    date: null,
    unavailable: false,
    currentTreatmentPlan: [],
    count: 0,

    // Availability button
    disableButton: false,

    // list to concatenate after receiving new data.
    currentAvailableList: {},
    daysAhead: 2,

    // will get the picked date and get timeSlots for the daysAhead of the chosenDate.
    chosenDate: null,

    withHomeShipping: false,

    kptOverride: null,
    treatmentDurationCorrection: 0,
    manufacturerOffice: false,
    withScanner: true,

    drivers: [],
  };

  componentWillUnmount() {
    this._isMounted = false;
    this.setState({
      date: null,
      chosenDate: null,
      available: {},
    });
  }

  handleData = data => {
    // this checks if it's not in the timeSlot
    if (this.state.date) {
      const { currentAvailableList, count, chosenDate, daysAhead } = this.state;

      let available = createSortedAvailableTimeWindows(
        data.additional_data.available_timewindows,
      );
      const code = data.code;

      if (
        code === `${ERROR_CODES.NO_RESULTS}` &&
        Object.keys(currentAvailableList).length === 0
      ) {
        this.setState({ unavailable: true });
      }

      this.setState(() => {
        // this is to concatenate Array of objects
        available = { ...currentAvailableList, ...available };

        return {
          available,
          currentAvailableList: available,
        };
      });

      // this request additional days ahead to be shown. daysAhead will be a variable.
      if (this.state.count < daysAhead) {
        // Skip weekend and go to next day.
        do {
          chosenDate.setDate(chosenDate.getDate() + 1);
        } while (!(chosenDate.getDay() % 6));

        this.getData(chosenDate);
        this.setState({
          available,
          count: count + 1,
        });
      }
    } else {
      // this callback is for the timeSlots handling
      const available = createSortedAvailableTimeWindows(
        data.additional_data.available_timewindows,
      );
      this.setState({
        available,
        currentAvailableList: {},
      });
    }
    return null;
  };

  // This handles the CheckAvailability
  async getData(date, timeSlot = null) {
    if (this._isMounted) {
      try {
        this.props.checkAvailability(
          date,
          timeSlot,
          this.toPlan,
          this.handleData,
          this.state.kptOverride,
          this.state.treatmentDurationCorrection,
          this.state.manufacturerOffice,
          this.state.withScanner,
        );

        this.setState({
          available: {},
          unavailable: false,
        });
      } catch (e) {
        this.setState({
          available: {},
        });
      }
    }
  }

  handleTimeSlots = (result, shouldGetData = true) => {
    // If we came from the timeSlotPage and we used a date, don't set a timeSlot.
    if (
      this.props.treatmentFromTimeSlot &&
      this.props.treatmentFromTimeSlot.date
    ) {
      return;
    }

    if (this.props.timeSlot) {
      this.handleTimeSlotChange(this.props.timeSlot);
      return;
    }

    const filtered = filterSortTimeSlots(result.slice());
    // Check if the treatment already has a timeSlot associated with it.
    if (this.toPlan && this.validateTimeSlotId(this.toPlan.plannedTimeSlotId)) {
      // if it does, select that timeSlot.
      const target = filtered.find(
        timeSlot => timeSlot.id === this.toPlan.plannedTimeSlotId,
      );
      if (target) {
        this.handleTimeSlotChange(target, shouldGetData);
        return;
      }
    }

    let target = null;
    for (const timeSlot of filtered) {
      const state = getStateFitting(
        this.props.treatmentToPlan.duration,
        timeSlot.durationMin,
        timeSlot.occupiedMin,
        timeSlot.maxGapMin,
      );
      if (state === STATES.EMPTY) {
        target = timeSlot;
        break;
      }
    }

    if (target !== null) {
      this.handleTimeSlotChange(target, shouldGetData);
    }
  };

  validateTimeSlotId(id) {
    return id !== null && id !== undefined && id > -1;
  }

  handleCurrentTreatmentPlan = () =>
    this.props.treatmentPlan.plannedTreatments.find(
      x => x.id === this.props.treatmentToPlan.id,
    );

  stateFromTimeSlot() {
    const { treatmentFromTimeSlot } = this.props;

    this.setState({
      date: moment(treatmentFromTimeSlot.date).toDate(),
    });
  }

  componentDidUpdate(prevProps){
    if (
      prevProps.treatmentDuration == null &&
      this.props.treatmentDuration != null
    ) {
      let params = new URLSearchParams(document.location.search);
      let treatmentduration = parseInt(params.get("duration"))
      // var requestedtreatmentduration = parseInt(window.localStorage.getItem("treatmentduration"))
      if(treatmentduration){
        this.setState({
          treatmentDurationCorrection:treatmentduration - this.props.treatmentDuration
        })
      }
    }
  }

  componentDidMount() {
    this._isMounted = true;
    window.isloaded = false
    window.loadcount = 0
    //get patient
    var patientid = document.location.pathname.split('/')[3]
    window.getPaul("patient","id",parseInt(patientid),(data) => {
      this.setState({
        patient:data[0],
        withHomeShipping:data[0].homeShipping,
      },() => {
        window.loadcount++
        this.afterLoad()
      })
    })
    // var inp = document.querySelector("#commentinput")
    let params = new URLSearchParams(document.location.search);
    let ptid = params.get("plannedtreatmentid");

    window.getPaul('plannedTreatment',"id",ptid,(data) => {
      this.setState({
        currentTreatmentPlan: data[0],
      },() => {

        window.loadcount++
        this.afterLoad()
      });
    })




    fetch(`${__URLS__["api"]}practices/allTreatments`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
    })
    .then(res => res.json())
    .then(alltreatments => {
      window.getPaul("plannedTreatment","id",ptid,(plannedtreatments) => {
        window.getPaul("treatmentPlan","id",plannedtreatments[0].treatmentPlanId,(treatmentplans) => {
          var tr = alltreatments.find(t => t.id == plannedtreatments[0].treatmentId)
          var duration = tr.duration
          tr.treatmentPlan = treatmentplans[0]
          this.setState({
            alltreatments:alltreatments,
            plannedTreatment2:plannedtreatments[0],
            treatment2:tr,
            description:treatmentplans[0].description,
            treatmentPlan:treatmentplans[0],
          },() => {

            window.loadcount++
            this.afterLoad()
          })
        })
      })
    })


    if(localStorage.getItem("selecteddate") != null){
      var datestring = localStorage.getItem("selecteddate")
      console.log("setdate",datestring)
      const date = parse(datestring, DATE_FORMATS.SIMPLE).toDate();
      this.setState({
        date: date,
      })
    }

    

    

    

 


    //end
  }

  afterLoad(){
    if(window.loadcount < 3){
      return
    }
    this.setState({loaded:true})
    window.isloaded = true
    


    const treatment = this.state.plannedTreatment2;
    this.toPlan = {
      id: treatment.id,
      treatmentPlanId: this.state.treatmentPlan.id,
      plannedTimeSlotId: -1,
      homeShipping: this.state.patient.homeShipping,
    };

    if (
      treatment.plannedTimeSlotId &&
      this.validateTimeSlotId(treatment.plannedTimeSlotId)
    ) {
      this.toPlan.plannedTimeSlotId = treatment.plannedTimeSlotId;
    }

    // // If we have a date through routing, use it.
    // if (history.location.state && history.location.state.date) {
    //   this.handleDateChanged(history.location.state.date);
    //   const timeslot = this.props.plannedTimeSlots.find(x =>
    //     moment(x.planned_date_time_from, DATE_FORMATS.BUMBAL).isSame(
    //       moment(history.location.state.date),
    //       "date",
    //     ),
    //   );

    //   if (timeslot && timeslot.id) {
    //     this.handleTimeSlotChange(timeslot);
    //   } else {
    //     this.setState({
    //       chosenDate: history.location.state.date,
    //       available: {},
    //       currentAvailableList: {},
    //       count: 2,
    //     });
    //     this.getData(history.location.state.date);
    //   }

    //   return;
    // }

    // here
    try {
      if (
        Object.keys(this.props.plannedTimeSlots).length === 0 &&
        !this.props.plannedTimeSlotsLoading
      ) {
        this.props.getPlannedTimeSlots(this.handleTimeSlots);
      } else {
        this.handleTimeSlots(this.props.plannedTimeSlots, false);
  
        // this is for checking if the treatments are planned and if to choose followUp
        if (this.props.treatments.filter(t => t.planned).length > 0) {
          this.handleFollowUpDay();
        } else if (this.props.patient && !this.props.patient.homeShipping) {
          this.checkFirstTimeSlot();
        }
      }
    } catch (error) {
      console.log(error)
    }

    if (hasRole(ROLES.Admin)) {
      this.props.onGetDrivers();
      this.props.onGetTreatmentDuration(
        this.state.plannedTreatment2.id,
        this.state.patient.homeShipping,
      );
    }

    if (this.props.treatmentFromTimeSlot) {
      this.stateFromTimeSlot();
    }

  }

  checkFirstTimeSlot() {
    const timeSlot = this.props.plannedTimeSlots.find(
      t =>
        getStateFitting(
          this.props.treatmentToPlan.duration,
          t.durationMin,
          t.occupiedMin,
          t.maxGapMin,
        ) === STATES.EMPTY,
    );
    if (!timeSlot) {
      return;
    }

    this.props.selectTimeWindow(null);
    this.props.onTimeSlotChanged(timeSlot);
    this.props.getTimeSlotData(timeSlot.id);
    this.getData(timeSlot.planned_date_time_from, timeSlot);
  }

  handleFollowUpDay = () => {
    this.setState({
      date: null,
    });

    // for follow up treatment, find the date of the previous treatment.
    let date = moment();
    let isFirst = true;
    for (const treatment of this.props.treatmentPlan.plannedTreatments) {
      // Parse the date to a moment date
      const _date = parse(
        treatment.planned_date_time_from,
        DATE_FORMATS.BUMBAL,
      );
      // Check if it is after the current date.
      if (_date && _date.isAfter(date)) {
        date = _date;
        isFirst = false;
      }
    }

    // Add the 14 day minimum difference between 2 appointments if this isn't the first.
    if (!isFirst) {
      date.add(14, "days");
    }

    // Checks the available timeSlots that are 14 days after the first and is not full
    const timeSlot = this.props.plannedTimeSlots.find(
      time =>
        moment(time.planned_date_time_from)
          .clone()
          .isSameOrAfter(date, "day") &&
        getStateFitting(
          this.props.treatmentToPlan.duration,
          time.durationMin,
          time.occupiedMin,
          time.maxGapMin,
        ) === STATES.EMPTY,
    );

    if (!timeSlot) {
      return;
    }

    this.props.selectTimeWindow(null);
    this.props.onTimeSlotChanged(timeSlot);
    this.props.getTimeSlotData(timeSlot.id);
    this.getData(timeSlot.planned_date_time_from, timeSlot);
  };

  handleDateChanged = date => {
    // this is to disable the checkAvailability Button when the days are not in the time frame.
    const value = moment(date);
    const maxDateFromSelected = !isOutOfMax(value);
    this.props.onTimeSlotChanged(null);
    if (!maxDateFromSelected) {
      this.setState({ disableButton: true });
    } else {
      this.props.getPlannedDays(value);
      this.props.selectTimeWindow();
      this.setState(prevState => {
        if (prevState.date && prevState.date.getTime() === date.getTime()) {
          return {};
        }
        return {
          disableButton: false,
          date,
          available: {},
        };
      });
    }
  };

  handleTimeWindowSelected = timeWindow => {
    this.props.selectTimeWindow({
      timeWindow,
      treatmentToPlan: this.toPlan,
      treatmentDurationCorrection: this.state.treatmentDurationCorrection,
      manufacturerOffice: this.state.manufacturerOffice,
      withScanner: this.state.withScanner,
    });
  };

  handleNextClicked = () => {
    if (!this.props.timeWindow) {
      return;
    }
    this.props.onNext();
  };

  handleKptOverrideSelect = selected => {
    this.setState({
      kptOverride: selected,
      disableButton: false,
    });
  };

  handleTimeSlotChange = (timeSlot, shouldGetData = true) => {
    // Get data on the new timeSlot, if it isn't the same
    // if (
    //   this.props.timeSlot &&
    //   timeSlot &&
    //   this.props.timeSlot.id === timeSlot.id
    // ) {
    //   return;
    // }

    // If timeslot is the same also get new data

    this.setState({
      date: null,
    });
    this.props.selectTimeWindow(null);
    this.props.onTimeSlotChanged(timeSlot);
    window.selectedTimeslot = timeSlot
    // timeSlot.planned_date_time_from
    // timeSlot.planned_date_time_to
    this.props.getTimeSlotData(timeSlot.id);
    if (shouldGetData) {
      this.getData(timeSlot.planned_date_time_from, timeSlot);
    }
  };

  handleCheckDateClicked = () => {
    console.log('checkdateclicked')
    window.selectedTimeslot = null

    localStorage.removeItem("selecteddate")
    const { timeSlot } = this.props;
    const { date } = this.state;

    this.setState({ disableButton: true });

    this.props.selectTimeWindow(null);

    if (timeSlot) {
      return this.getData(timeSlot.planned_date_time_from, timeSlot);
    }
    if (date) {
      this.setState({
        chosenDate: date,
        available: {},
        currentAvailableList: {},
        count: 0,
      });
      return this.getData(date);
    }

    return null;
  };

  handleEditTimeSlotClicked = () => {
    let date = this.state.date;
    if (this.props.timeSlot) {
      date = parse(
        this.props.timeSlot.planned_date_time_from,
        DATE_FORMATS.BUMBAL,
      );
    } else {
      date = moment(date);
    }

    if (!date.isValid()) {
      return;
    }

    this.props.setTreatmentFromTimeSlot({
      date,
      timeSlot: this.props.timeSlot,
      treatmentToPlan: this.props.treatmentToPlan,
      patient: this.props.patient,
      treatmentPlan: this.props.treatmentPlan,
    });
    history.push({
      pathname: `/timeslots/${date.format(DATE_FORMATS.SIMPLE)}`,
      isFromTreatments: true,
    });
  };

  renderDatePicker() {
    if (this.state.unavailable) {
      return (
        <CenterText style={{ color: "red" }}>
          <FormattedMessage {...messages.noOpenTimeWindows} />
        </CenterText>
      );
    }

    if (this.state.available) {
      return (
        <TreatmentDatePicker
          onTimeWindowSelected={this.handleTimeWindowSelected}
          timeWindows={this.state.available}
          locale={this.props.locale}
        />
      );
    }

    return null;
  }

  renderKptOverrideButton() {
    return (
      <FormControl
        style={{
          minWidth: "200px",
          maxWidth: "250px",
          marginTop: "10px",
          marginBottom: "10px",
          width: "100%",
        }}
        disabled={this.props.loading}
      >
        <InputLabel shrink>
          <FormattedMessage {...messages.kptOverrideTitle} />
        </InputLabel>
        <Select
          displayEmpty
          fullWidth
          value={this.state.kptOverride}
          onChange={val => {
            this.handleKptOverrideSelect(val.target.value);
          }}
        >
          <MenuItem key={1} value={null}>
            <FormattedMessage {...messages.kptOverrideEmpty} />
          </MenuItem>
          {(this.props.drivers || []).map(driver => (
            <MenuItem key={`driver_${driver.id}`} value={driver.id}>
              {driver.first_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  renderDurationChangeButton() {
    return (
      <FormControl
        style={{
          minWidth: "150px",
          maxWidth: "200px",
          width: "100%",
        }}
        disabled={this.props.loading}
      >
        <DurationPicker
          loading={this.props.loading}
          min={15}
          max={180}
          noLoop={true}
          duration={
            this.props.treatmentDuration +
            this.state.treatmentDurationCorrection
          }
          onChange={value => {
            this.setState({
              available: {},
              disableButton: false,
              treatmentDurationCorrection: value - this.props.treatmentDuration,
            });
          }}
        />
      </FormControl>
    );
  }

  renderHomeShippingButton() {
    return (
      <FormControl
        style={{
          minWidth: "150px",
          maxWidth: "200px",
          width: "100%",
        }}
      >
        <ToggleButton
          disabled={this.props.loading}
          onChange={({ value }) => {
            this.setState({
              withHomeShipping: value,
              manufacturerOffice: false,
            });
            this.props.onGetTreatmentDuration(
              this.props.treatmentToPlan.id,
              value,
            );
            this.toPlan.homeShipping = value;
            this.setState({ available: {} });
            this.props.onTimeSlotChanged(null);
            this.props.selectTimeWindow(null);
          }}
          label={<FormattedMessage {...OrderMessages.homeTreatment} />}
          options={[
            {
              value: true,
              id: 1,
              label: <FormattedMessage {...GlobalMessages.yesButtonText} />,
            },
            {
              value: false,
              id: 2,
              label: <FormattedMessage {...GlobalMessages.noButtonText} />,
            },
          ]}
          value={this.state.withHomeShipping}
        />
      </FormControl>
    );
  }

  renderManufacturerButton() {
    return (
      <FormControl
        style={{
          minWidth: "150px",
          maxWidth: "200px",
          width: "100%",
        }}
      >
        <ToggleButton
          disabled={this.props.loading}
          onChange={({ value }) => {
            this.setState({
              withHomeShipping: false,
              manufacturerOffice: value,
            });
            this.props.onGetTreatmentDuration(
              this.props.treatmentToPlan.id,
              false,
            );
            this.toPlan.homeShipping = false;
            this.setState({ available: {} });
            this.props.onTimeSlotChanged(null);
            this.props.selectTimeWindow(null);
          }}
          label={<FormattedMessage {...GlobalMessages.gds} />}
          options={[
            {
              value: true,
              id: 1,
              label: <FormattedMessage {...GlobalMessages.yesButtonText} />,
            },
            {
              value: false,
              id: 2,
              label: <FormattedMessage {...GlobalMessages.noButtonText} />,
            },
          ]}
          value={this.state.manufacturerOffice}
        />
      </FormControl>
    );
  }

  renderScannerButton() {
    return (
      <FormControl
        style={{
          minWidth: "150px",
          maxWidth: "200px",
          width: "100%",
        }}
      >
        <ToggleButton
          disabled={this.props.loading}
          onChange={({ value }) => {
            this.setState({ withScanner: value });
            this.setState({ available: {} });
            this.props.onTimeSlotChanged(null);
            this.props.selectTimeWindow(null);
          }}
          label={<FormattedMessage {...GlobalMessages.withScanner} />}
          options={[
            {
              value: true,
              id: 1,
              label: <FormattedMessage {...GlobalMessages.yesButtonText} />,
            },
            {
              value: false,
              id: 2,
              label: <FormattedMessage {...GlobalMessages.noButtonText} />,
            },
          ]}
          value={this.state.withScanner}
        />
      </FormControl>
    );
  }

  render() {
    if(this.state.loaded == undefined){
      return null
    }
    console.log('newtreatmentplanningstep')
    // if (!this.props.treatmentPlan || !this.props.treatmentToPlan) {
    //   return null;
    // }
    // if(this.state.alltreatments == null || this.state.plannedTreatment2 == null){
    //   return null
    // }
    this.state.alltreatments
    this.state.plannedTreatment2
    

    const showDateChart =
      this.props.timeSlot &&
      this.props.timeSlotData &&
      !this.props.timeSlotDataLoading;

    const showCheckButton = !this.props.timeSlot && this.state.date;
    let timeSlotIndex = -1;
    if (this.props.timeSlot) {
      timeSlotIndex = this.props.plannedTimeSlots.findIndex(
        t => t.id === this.props.timeSlot.id,
      );
    }

    return (
      <>
        <DocumentOrderModal
          onClose={this.props.handleCloseModal}
          title={
            <FormattedMessage
              {...GlobalMessages.dataNotSavedModalAppointmentTitle}
            />
          }
          isOpen={this.props.showModal}
          onConfirm={this.props.onClose}
          content={
            <FormattedMessage
              {...GlobalMessages.are_you_sure_you_want_to_go_back}
            />
          }
        />
        <NewTreatmentHeader
          onClose={this.props.handleModalOpen}
          enableLargePadding
        />
        <StepArrows
          noLeft
          rightDisabled // leftDisabled={!!history.location.plannedTreatment}
          onBack={this.props.onBack}
          leftTransparent={this.props.loading}
        >
          <Content>
            <LeftContent>
              <div>
                <AgendaPlannedTreatment
                  admin={false}
                  newAppointment={true}
                  patient={this.props.patient}
                  practice={this.props.practice}
                  
                  duration={this.state.treatment2.duration}
                  treatment={{
                    ...this.state.plannedTreatment2,
                    // ...this.props.treatments.find(
                    //   t => t.id === this.props.treatmentToPlan.id,
                    // ),
                    homeShipping: this.state.withHomeShipping,
                    duration:this.state.treatment2.duration,
                    treatmentPlan: this.state.treatmentPlan,
                  }}
                  withPracticeInfo={false}
                />
              </div>

              <DayChartWrapper>
                {showDateChart ? (
                  <>
                    <DayChart
                      times={this.props.timeSlotData}
                      timeBlocks={this.props.timeSlotData.plannedTreatments.map(
                        treatment => ({
                          ...treatment,
                          children: (
                            <TreatmentNameContainer>
                              {treatment.patientName}
                            </TreatmentNameContainer>
                          ),
                        }),
                      )}
                      width="100%"
                      height="30rem"
                    />
                    <EditTimeSlotContainer>
                      <IconActionButton
                        fullWidth
                        icon={<EditIcon />}
                        onClick={this.handleEditTimeSlotClicked}
                      >
                        <FormattedMessage {...GlobalMessages.editTimeSlot} />
                      </IconActionButton>
                    </EditTimeSlotContainer>
                  </>
                ) : (
                  this.props.plannedDays && (
                    <DayChart
                      times={buildTimes(toMoment(this.props.plannedDays.date))}
                      dayparts={this.props.plannedDays.plannedTimeSlots}
                      timeBlocks={[
                        ...((this.props.plannedDays.plannedTimeSlots[0] || {})
                          .plannedTreatments || []),
                        ...this.props.plannedDays.plannedTreatments,
                      ].map(treatment => ({
                        ...treatment,
                        children: (
                          <TreatmentNameContainer>
                            {treatment.patientName}
                          </TreatmentNameContainer>
                        ),
                      }))}
                      width="100%"
                      height="30rem"
                    />
                  )
                )}
              </DayChartWrapper>
            </LeftContent>
            <RightContent style={{background:"white", borderRadius:"5px",marginLeft:"10px", border:"1px solid black"}}>
              <Grid container spacing={4}>
                {this.props.patient.homeShipping && (
                  <Grid item xs sm md>
                    {this.renderHomeShippingButton()}
                  </Grid>
                )}
                {hasRole(ROLES.Admin) && (
                  <Grid item xs sm md>
                    {this.renderDurationChangeButton()}
                  </Grid>
                )}
                {hasRole(ROLES.Admin) && (
                  <Grid item xs sm md>
                    {this.renderManufacturerButton()}
                  </Grid>
                )}
                {hasRole(ROLES.Admin, ROLES.CS) && (
                  <Grid item xs sm md>
                    {this.renderScannerButton()}
                  </Grid>
                )}
                {hasRole(ROLES.Admin) && (
                  <Grid item xs sm md>
                    {this.renderKptOverrideButton()}
                  </Grid>
                )}
              </Grid>

              {!this.state.manufacturerOffice &&
                !this.state.withHomeShipping && (
                  <div>
                    <CenterText>
                      <Header>
                        <FormattedMessage {...messages.selectTimeSlot} />
                      </Header>
                      <SubHeader>
                        <FormattedMessage {...messages.yourTimeSlots} />
                      </SubHeader>
                    </CenterText>
                    <DateBlocks
                      selectedIndex={timeSlotIndex}
                      duration={this.state.treatment2.duration}
                      dates={this.props.plannedTimeSlots.slice()}
                      onClick={this.handleTimeSlotChange}
                      colorFunction={getColorFitting}
                      plannedTreatmentId={this.state.plannedTreatment2.id}
                    />
                    <Divider />
                  </div>
                )}
              {this.props.loading && <LoadingAnimation contained />}
              {this.renderDatePicker()}
              {this.props.timeWindow && (
                <PlanContent>
                  <ActionButtonWrapper>
                    <ActionButton
                      onClick={this.handleNextClicked}
                      variant="contained"
                      id="planButton"
                    >
                      <FormattedMessage {...GlobalMessages.planTreatment} />
                    </ActionButton>
                  </ActionButtonWrapper>
                </PlanContent>
              )}

              {this.props.checkAvailabilityFailedMessage && (
                <WarningText>
                  <WarningMessages
                    messages={[
                      this.props.checkAvailabilityFailedMessage.message,
                    ]}
                  />
                </WarningText>
              )}

{/* here */}
              {!this.state.plannedTreatment2.onlyInTimeSlot ||
              hasRole([ROLES.Admin, ROLES.KPT, ROLES.CS]) ? (
                <>
                  <CenterText>
                    <FormattedMessage {...messages.noValidOptions} />
                  </CenterText>

                  <Divider empty />

                  <DatePickerContainer>
                    <DatePickerWrapper>
                      <DateTimePicker
                        minDate={moment().toDate()}
                        onChange={this.handleDateChanged}
                        value={this.state.date}
                        highlightedValue={this.props.plannedTimeSlots}
                        treatments={this.props.agendaTreatments}
                      />
                    </DatePickerWrapper>
                  </DatePickerContainer>
                  
                  <div style={{display:"flex",justifyContent:"center", marginBottom:"20px"}}>


                  </div>

                  {showCheckButton && (
                    <CheckButtonWrapper>
                      <ActionButton
                        id="checkAvailabilityButton"
                        disabled={this.state.disableButton}
                        onClick={this.handleCheckDateClicked}
                      >
                        <FormattedMessage
                          {...GlobalMessages.checkAvailability}
                        />
                      </ActionButton>
                    </CheckButtonWrapper>
                  )}
                </>
              ) : (
                <CenterText>
                  <FormattedMessage {...messages.onlyPossibleToPlanInDayPart} />
                </CenterText>
              )}

                <div style={{display:"flex",justifyContent:"center", marginBottom:"20px",gap:"10px"}}>
                  <CustomInputComponent 
                    fullWidth
                    onChange={e => {
                      this.setState({description:e.target.value})
                    }}
                    value={this.state.description ?? ""}
                    label={"Comment"}
                  ></CustomInputComponent>
                  <RefrezhButton onClick={() => {
                    let params = new URLSearchParams(document.location.search);
                    let ptid = params.get("plannedtreatmentid");
                    window.getPaul("plannedTreatment","id",ptid,(data) => {
                      window.updatePaul("treatmentPlan",data[0].treatmentPlanId,"description",this.state.description,() => {
                        // location.reload()
                      })
                    })
                  }}><span style={{whiteSpace:"nowrap"}}>Save comment</span></RefrezhButton>
              </div>
            </RightContent>
          </Content>
        </StepArrows>
      </>
    );
  }
}

const TreatmentNameContainer = styled.div`
  padding-left: ${({ theme }) => theme.padding}rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 5px;
`;

const EditTimeSlotContainer = styled.div`
  width: 100%;
  min-width: 285px;
  margin-top: ${({ theme }) => theme.margin}rem;
`;

const CheckButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${({ theme }) => theme.margin}rem;
`;

const DayChartWrapper = styled.div`
  margin-top: ${({ theme }) => theme.margin}rem;
  //min-height: 542px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Divider = styled.div`
  width: 100%;
  ${({ empty, theme }) =>
    !empty && `border-bottom: 1px solid ${theme.borderColor}`};
  margin-top: ${({ theme }) => theme.margin}rem;
  margin-bottom: ${({ theme }) => theme.margin}rem;
`;

const DatePickerContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.margin}rem;
`;

const DatePickerWrapper = styled.div`
  width: 250px;
`;

const CenterText = styled.div`
  text-align: center;
  width: 100%;
`;

const ActionButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.padding}rem;
  margin-top: ${({ theme }) => theme.marginHuge}rem;
`;

const LeftContent = styled.div`
  border-right: 1px solid ${({ theme }) => theme.borderColor};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* grid-area: patient; */
  padding: 20px;
  padding-top: 0;
`;

const RightContent = styled.div`
  /* grid-area: dates; */
  padding: 20px 20px 0 4rem;
  width: 100%;
`;

const PlanContent = styled.div`
  /* grid-area: plan; */
  position: relative;
  min-height: 8vh;
  margin-right: 0.9rem;
  margin-left: 0.9rem;
`;

const Content = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

const WarningText = styled.div`
  display: flex;
  justify-content: center;
`;
let showtoday = hasRole([ROLES.Admin,ROLES.CS])
const mapStateToProps = createStructuredSelector({
  currentPractice: makeSelectPractice(),
  plannedTimeSlots: makeSelectPlannedTimeSlots(!showtoday),
  plannedTimeSlotsLoading: makeSelectPlannedTimeSlotsLoading(),
  treatmentToPlan: makeSelectTreatmentToPlan(),
  timeWindow: makeSelectTimeWindow(),
  treatments: makeSelectTreatmentsNewTreatment(),
  treatmentPlan: makeSelectTreatmentPlan(),
  locale: makeSelectLocale(),
  timeSlotData: makeSelectTimeSlotData(),
  timeSlotDataLoading: makeSelectTimeSlotDataLoading(),
  patient: makeSelectPatient(),
  timeSlot: makeSelectTimeSlot(),
  checkAvailabilityFailedMessage: makeSelectCheckAvailabilityFailedMessage(),
  loading: makeSelectCheckAvailabilityLoading(),
  treatmentFromTimeSlot: makeSelectTreatmentFromTimeSlot(),
  agendaTreatments: makeSelectTreatments(),
  plannedDays: makeSelectPlannedDay(),
  drivers: makeSelectTreatmentDrivers(),
  treatmentDuration: makeSelectTreatmentDuration(),
});

function mapDispatchToProps(dispatch) {
  return {
    getTimeSlotData: timeSlotId => dispatch(getTimeSlotDataAction(timeSlotId)),
    getPlannedTimeSlots: callback =>
      dispatch(getPlannedTimeSlotsAction(callback)),
    getPlannedDays: date => dispatch(getPlannedDays(date)),
    selectTimeWindow: timeWindow => dispatch(selectTimeWindow(timeWindow)),
    onTimeSlotChanged: timeSlot => dispatch(selectTimeSlot(timeSlot)),
    checkAvailability: (
      date,
      timeSlot,
      toPlan,
      callback,
      kptOverride,
      treatmentDurationCorrection,
      manufacturerOffice,
      withScanner,
    ) =>
      dispatch(
        checkAvailability(
          date,
          timeSlot,
          toPlan,
          callback,
          kptOverride,
          treatmentDurationCorrection,
          manufacturerOffice,
          withScanner,
        ),
      ),
    setTreatmentFromTimeSlot: value =>
      dispatch(setTreatmentFromTimeSlotAction(value)),
    onGetDrivers: () => dispatch(getTreatmentDrivers()),
    onGetTreatmentDuration: (ptId, homeShipping) =>
      dispatch(getTreatmentDuration(ptId, homeShipping)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(NewTreatmentPlanningStep);
